export const colors = {
  bg1: "#182B49",
  bg2: "#F6F9FF",
  gr_bg: "linear-gradient(90deg, #11B67A 0%, #009444 100%)",
  gr_bg2: "linear-gradient(90deg, #009444 0%, #11B67A 100%)",
  red_bg: "linear-gradient(90deg, #FF0000 0%, #FF3B3B 80%, #FF6F6F 100%)",
  red_bg2: "linear-gradient(90deg, #FF6F6F 0%, #FF3B3B 80%, #FF3B3B 100%)",
  copy_bg2: "linear-gradient(90deg, #4A6BA0 0%, #1A2C50 50%, #0F1F3C  100%)",
  copy_bg: "#122340",
  blue: "#2c97ea",
  green: "#11B67A",
  green2: "#00a76a",
  red2: "#FF6F6F",
  red: "#FF0000",
  purple: "#84479c",
  yellow: "#fbab19",
  black1: "#182B49",
  black2: "#444444",
  text1: "#555555",
  text2: "#666666",
  text3: "#969696",
  text4: "#aaaaaa",
  text5: "#cccccc",
  border1: "#eeeeee",
  border2: "#3e3e3e",
  border3: "#dddddd",
  footer1: "#1a1b25",
  footer2: "#16171f",
  ftext: "#8D8E92",
};

export const fonts = {
  roboto: "'Roboto', sans-serif",
  poppins: "'Poppins', sans-serif",
};
